import theme_icons from '../../icons.js';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { InspectorControls, ColorPalette } = wp.blockEditor;
const { PanelBody, SelectControl, TextControl } = wp.components;

const programswidget = {
    title: 'Programs Query',
    icon: theme_icons.greenheart,
    category: 'greenheart',
    //attributes
    attributes: {
        background_color: {
            type: 'string',
            default: ''
        },
        format: {
            type: 'string',
            default: ''
        },
        per_page: {
            type: 'number',
            default: 12
        },
        trigger: {
            type: 'string',
            default: ''
        },
        picker: {                    // ← new
            type: 'string',
            default: 'default'
        }
    },

    edit({ attributes, setAttributes }) {
        const { background_color, format, per_page, trigger, picker } = attributes;  // ← picker added

        return ([
            <InspectorControls>
                <PanelBody title={__('Settings')}>

                    <p>Background Color</p>
                    <ColorPalette
                        value={background_color}
                        onChange={(colorValue) => setAttributes({ background_color: colorValue })}
                    />

                    <p>Results per page:</p>
                    <TextControl
                        type="number"
                        value={per_page}
                        onChange={(e) => setAttributes({ per_page: e.target.value })}
                    />

                    <p>Format</p>
                    <SelectControl
                        value={format}
                        options={[
                            { label: 'List', value: 'list' },
                            { label: 'Grid', value: 'grid' },
                            { label: 'Card', value: 'card' },
                            { label: 'Condensed', value: 'condensed' }
                        ]}
                        onChange={(val) => setAttributes({ format: val })}
                    />

                    <p>Trigger</p>
                    <p>(OnChange trigger re-queries whenever a filter value is changed. Button provides a Go button)</p>
                    <SelectControl
                        value={trigger}
                        options={[
                            { label: 'OnChange', value: 'onchange' },
                            { label: 'Button', value: 'button' }
                        ]}
                        onChange={(val) => setAttributes({ trigger: val })}
                    />

                    <p>Picker</p>                   {/* ← new */}
                    <p>(Controls the dropdown picker style shown with results)</p>
                    <SelectControl
                        value={picker}
                        options={[
                            { label: 'Default', value: 'default' },
                            { label: 'Regions', value: 'regions' },
                            { label: 'None', value: 'none' }
                        ]}
                        onChange={(val) => setAttributes({ picker: val })}
                    />

                </PanelBody>
            </InspectorControls>,
            <div className="rbt-programswidget" style={{ backgroundColor: background_color }}>
                {format === 'list' && (
                    <img src={"/wp-content/plugins/GreenheartBlockEngineTravel/assets/thumbs/list.png"} />
                )}
                {format === 'card' && (
                    <img src={"/wp-content/plugins/GreenheartBlockEngineTravel/assets/thumbs/cards.png"} />
                )}
                {format === 'condensed' && (
                    <img src={"/wp-content/plugins/GreenheartBlockEngineTravel/assets/thumbs/condensed.png"} />
                )}
                {!format && (
                    <img src={"/wp-content/plugins/GreenheartBlockEngineTravel/assets/thumbs/list.png"} />
                )}
            </div>
        ]);
    },
    save({ attributes }) { return null; }
};

registerBlockType('rbt/programswidget', programswidget);
export default programswidget;

// import theme_icons from './blocks.js';

// const { __ } = wp.i18n;
// const { registerBlockType } = wp.blocks; 
// const { RichText } = wp.blockEditor; 

// const programswidget = {
// 	title: 'Please Create Unique Title',
// 	icon: theme_icons.greenheart,
//     category: 'greenheart',
//     //attributes
//     attributes: {
//         title:{
//             type: 'string',
//             default: ''
//         },
//         text: {
//             type: 'string',
//             default: ''
//         },
//     },

// 	edit({attributes, setAttributes}){
// 		const { title, text } = attributes;

//         function onTextChange(newtext){
//         	setAttributes({ text: newtext });
//         }
//         function onTitleChange(newtitle){
//             setAttributes({title:newtitle});
//         }

// 		return (
//             <div className="rbt-programswidget">
//                 <RichText 
//                     tagName="h3"
//                     className="accordion"
//                     value={title}
//                     onChange={onTitleChange}
//                     placeholder={ 'Accordion Title' }
//                 />
//                 <RichText 
//                     tagName="div"
//                     className="[!PLUGINPATH!]-accordion-panel"
//                     value = {text}
//                     onChange={onTextChange}
//                     placeholder={ 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'}
//                 />   
//             </div>
// 		);
// 	},
// 	save({attributes}) { return null; }
// };

